var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile__tabs-wrapper"},[_c('tabs',{attrs:{"tabs":_vm.tabs},on:{"click":function($event){return _vm.$emit('click', $event)}},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }